import { L98, defaultTheme } from "@adfenix/alexandria";

import { createGlobalStyle } from "styled-components";
import { globalMixin } from "style/mixins";

const $size1 = "3rem";
const $size2 = "2.5rem";
const $size3 = "2rem";
const $size4 = "1.5rem";
const $size5 = "1.25rem";
const $size6 = "1rem";
const $size7 = "0.75rem";

const GlobalStyle = createGlobalStyle`

  // Define CSS variables that are referenced by Bulma stylesheets etc.
  :root {
    --body-font: ${({ theme }) => theme.bodyFont};
    --heading-font: ${({ theme }) => theme.headingFont};
    --mobile-base-font-size: 14px
  }

  * {
    font-family: ${({ theme }) => theme.bodyFont};
  }

  html {
    line-height: 1.5;
    scroll-behavior: smooth;
    -webkit-font-smoothing: antialiased;
    text-size-adjust: 100%;
    font-family: ${({ theme }) => theme.bodyFont};
    font-size: 16px;
    font-weight: normal;
    ${({ theme }) => theme.breakpoints.mobileAndLower} {
      font-size: var(--mobile-base-font-size);
      line-height: 1.25;
    }
  }

  [hidden] {
    display: none !important;
  }

  body {
    color: ${({ theme }) => theme.colors.black};
    background-color:  ${({ theme }) => L98(theme.colors.grey)}; 
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    min-height: 100vh;
    margin: 0;

    @media print {
      background: #fff;
    }
  }

  .ReactCollapse--collapse {
    transition: height 450ms ${defaultTheme.bezierCurve};
  }

  h1,
  h2,
  h3,
  h4,
  h5, 
  h6 {
  font-family: ${({ theme }) => theme.headingFont} ;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};

  &.title {
    font-weight: 500;
    line-height: 1.5;
    margin-bottom: ${$size6} !important;
    color: ${({ theme }) => theme.colors.black}
    }
  }

  @media screen and (max-width: 768px) {
    .media-content {
      overflow-x: inherit;
    }
  }

  ${globalMixin}

  .my-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
  
  .my-1 {
    margin-top: ${$size7} !important;
    margin-bottom: ${$size7} !important;
  }

  .my-2 {
    margin-top: ${$size6} !important;
    margin-bottom: ${$size6} !important;
  }

  .my-3 {
    margin-top: ${$size5} !important;
    margin-bottom: ${$size5} !important;
  }

  .my-4 {
    margin-top: ${$size4} !important;
    margin-bottom: ${$size4} !important;
  }

  .my-5 {
    margin-top: ${$size3} !important;
    margin-bottom: ${$size3} !important;
  }

  .my-6 {
    margin-top: ${$size2} !important;
    margin-bottom: ${$size2} !important;
  }

  .my-7 {
    margin-top: ${$size1} !important;
    margin-bottom: ${$size1} !important;
  }

  .mt-0 {
    margin-top: 0 !important;
  }
  .mt-1 {
    margin-top: ${$size7} !important;
  }

  .mt-2 {
    margin-top: ${$size6} !important;
  }

  .mt-3 {
    margin-top: ${$size5} !important;
  }

  .mt-4 {
    margin-top: ${$size4} !important;
  }

  .mt-5 {
    margin-top: ${$size3} !important;
  }

  .mt-6 {
    margin-top: ${$size2} !important;
  }

  .mt-7 {
    margin-top: ${$size1} !important;
  }

  // Margin Right
  .mr-0 {
    margin-right: 0 !important;
  }
  .mr-1 {
    margin-right: ${$size7} !important;
  }

  .mr-2 {
    margin-right: ${$size6} !important;
  }

  .mr-3 {
    margin-right: ${$size5} !important;
  }

  .mr-4 {
    margin-right: ${$size4} !important;
  }

  .mr-5 {
    margin-right: ${$size3} !important;
  }

  .mr-6 {
    margin-right: ${$size2} !important;
  }

  .mr-7 {
    margin-right: ${$size1} !important;
  }

  // Margin Bottom
  .mb-1 {
    margin-bottom: ${$size7} !important;
  }

  .mb-2 {
    margin-bottom: ${$size6} !important;
  }

  .mb-3 {
    margin-bottom: ${$size5} !important;
  }

  .mb-4 {
    margin-bottom: ${$size4} !important;
  }

  .mb-5 {
    margin-bottom: ${$size3} !important;
  }

  .mb-6 {
    margin-bottom: ${$size2} !important;
  }

  .mb-7 {
    margin-bottom: ${$size1} !important;
  }

  // Margin Bottom
  .ml-0 {
    margin-left: 0 !important;
  }
  .ml-1 {
    margin-left: ${$size7} !important;
  }

  .ml-2 {
    margin-left: ${$size6} !important;
  }

  .ml-3 {
    margin-left: ${$size5} !important;
  }

  .ml-4 {
    margin-left: ${$size4} !important;
  }

  .ml-5 {
    margin-left: ${$size3} !important;
  }

  .ml-6 {
    margin-left: ${$size2} !important;
  }

  .ml-7 {
    margin-left: ${$size1} !important;
  }

  // Padding Top + Bottom
  .py-1 {
    padding-bottom: ${$size7} !important;
    padding-top: ${$size7} !important;
  }

  .py-2 {
    padding-bottom: ${$size6} !important;
    padding-top: ${$size6} !important;
  }

  .py-3 {
    padding-bottom: ${$size5} !important;
    padding-top: ${$size5} !important;
  }

  .py-4 {
    padding-bottom: ${$size4} !important;
    padding-top: ${$size4} !important;
  }

  .py-5 {
    padding-bottom: ${$size3} !important;
    padding-top: ${$size3} !important;
  }

  .py-6 {
    padding-bottom: ${$size2} !important;
    padding-top: ${$size2} !important;
  }

  .py-7 {
    padding-bottom: ${$size1} !important;
    padding-top: ${$size1} !important;
  }

  .p-1 {
    padding-bottom: ${$size7} !important;
    padding-top: ${$size7} !important;
    padding-left: ${$size7} !important;
    padding-right: ${$size7} !important;
  }

  .p-2 {
    padding-bottom: ${$size6} !important;
    padding-top: ${$size6} !important;
    padding-left: ${$size6} !important;
    padding-right: ${$size6} !important;
  }

  .p-3 {
    padding-bottom: ${$size5} !important;
    padding-top: ${$size5} !important;
    padding-left: ${$size5} !important;
    padding-right: ${$size5} !important;
  }

  .p-4 {
    padding-bottom: ${$size4} !important;
    padding-top: ${$size4} !important;
    padding-left: ${$size4} !important;
    padding-right: ${$size4} !important;
  }

  .p-5 {
    padding-bottom: ${$size3} !important;
    padding-top: ${$size3} !important;
    padding-left: ${$size3} !important;
    padding-right: ${$size3} !important;
  }

  .p-6 {
    padding-bottom: ${$size2} !important;
    padding-top: ${$size2} !important;
    padding-left: ${$size2} !important;
    padding-right: ${$size2} !important;
  }

  .p-7 {
    padding-bottom: ${$size1} !important;
    padding-top: ${$size1} !important;
    padding-left: ${$size1} !important;
    padding-right: ${$size1} !important;
  }

  .pt-1 {
    padding-top: ${$size7} !important;
  }

  .pt-2 {
    padding-top: ${$size6} !important;
  }

  .pt-3 {
    padding-top: ${$size5} !important;
  }

  .pt-4 {
    padding-top: ${$size4} !important;
  }

  .pt-5 {
    padding-top: ${$size3} !important;
  }

  .pt-6 {
    padding-top: ${$size2} !important;
  }

  .pt-7 {
    padding-top: ${$size1} !important;
  }

  .Toastify__toast--adfenix {
    border-radius: 4px;
    min-height: 32px;
    font-size: 16px;
    font-family: ${({ theme }) => theme.bodyFont};
    font-weight: 600;
    box-shadow: none;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 4px;
  }

  .Toastify__toast-body--centered {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    margin: 0;
  }

  /* SVG icons can sometime appear a pixel or two outside the viewbox.  */
  /* This ensures they are still visible when it happens */
  .rf-icon {
    overflow: visible;
  }
`;
export default GlobalStyle;
